export default __webpack_public_path__ + "static/media/clouds.397e7326.png";